/*@flow*/
import type { Node } from 'react';
import React, { useState } from 'react';
import Select from 'react-select';
import nested from 'lib/nested';
import useCachedQuery from 'lib/useCachedQuery';
import GetDataPanels from 'comps/Left2/queries/GetDataPanels';
import getBbox from 'lib/getBbox';
import useError from 'lib/useError';

type PropsT = {
  onChange: Function,
};

const panels2Opts = (vs, panels) =>
  panels
    .filter((v) => vs.includes(String(v.id)))
    .map((v) => ({ label: v.name, value: v.id }));

const styles = {
  valueContainer: (v) => {
    return {
      ...v,
      padding: 0,
    };
  },
  control: (v) => {
    const borderColor = 'hsl(0, 0%, 80%)';
    return {
      ...v,
      boxShadow: 'none',
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      borderColor,
      borderRadius: 0,
      '&:hover': {
        borderColor,
      },
    };
  },
};

export default ({ onChange }: PropsT): Node => {
  const [selected, onSelect] = useState([]);
  const bbox = getBbox();
  const opts = {
    variables: { bbox, ids: null },
  };
  const { data, loading, error } = useCachedQuery(GetDataPanels, opts);
  useError(error);

  const panels = nested(data, 'dataPanels', []);

  return (
    <Select
      isMulti
      onChange={(v) => {
        if (!Array.isArray(v)) return;
        const values = v.map((v2) => v2.value);
        onSelect(values);
        onChange(values);
      }}
      isLoading={loading}
      clearable
      classNamePrefix="Select"
      value={panels2Opts(selected, panels)}
      placeholder="Search data panels"
      options={panels.map((v) => ({ label: v.name, value: v.id }))}
      name="dataPanels"
      style={{ width: '100%' }}
      styles={styles}
    />
  );
};
